import React from "react";
import GenericCard from "@ui-components/Card/GenericCard";
import { GenericTag } from "@ui-components/Tag/GenericTag";
import { useExtenderPopConnections } from "./ExtenderPopConnections";
import { summarizeConnections } from "./extenderPopConnectionsData";

/**
 * Summary of what the whole site delivers: one row per type of connection
 * with how many there are and how they are doing. The connections one by
 * one live in each CPE's detail.
 */
export default function ExtenderPopConnectionsSummary({
  extenderPopId,
  tenantId,
}: {
  extenderPopId: number;
  tenantId: number;
}) {
  const { data, isLoading } = useExtenderPopConnections(extenderPopId, tenantId);
  const rows = summarizeConnections(data ?? []);

  return (
    <GenericCard
      isLoading={isLoading}
      headerContent="Connections"
      isCollapsible={false}
      bodyContent={
        rows.length === 0 ? (
          <p className="py-1.5 text-sm text-semantic-text-secondary">
            This Extended PoP delivers no connection yet.
          </p>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="text-left text-semantic-text-secondary">
                  <th className="py-1.5 pr-4 font-normal">Type</th>
                  <th className="py-1.5 pr-4 font-normal">Connections</th>
                  <th className="py-1.5 font-normal">Status</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row) => (
                  <tr
                    key={row.type}
                    className="border-t border-semantic-border-secondary text-semantic-text-primary"
                  >
                    <td className="py-1.5 pr-4">{row.label}</td>
                    <td className="py-1.5 pr-4">{row.total}</td>
                    <td className="py-1.5">
                      <div className="flex flex-wrap gap-2">
                        {row.statuses.map((status) => (
                          <GenericTag
                            key={status.label}
                            variant={status.variant}
                            label={`${status.label} ${status.count}`}
                            size="small"
                          />
                        ))}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )
      }
    />
  );
}
